<template>
 <div class="propertyCard">

        <!-- header -->
        <div class="propertyCard__header">
            <base-tag>{{ property.data.buildingUse }}</base-tag>
        </div>

        <!-- body -->
        <div class="propertyCard__body">
            <div class="propertyCard__main">
                <div class="propertyCard__left">
                    <div class="propertyCard__image">
                        <el-image :src="property.data.imageUrl"></el-image>
                    </div>
                </div>
                <div class="propertyCard__right">
                    <div class="propertyCard__outline">
                        <div class="priceBox"><p>{{ changeJpPrice(property.data.price) }}円</p></div>
                        <div class="grossBox" v-if="property.data.gross"><p>利回り：<span class="grossBox--value">{{ property.data.gross }}%</span></p></div>
                    </div>

                    <div class="propertyCard__detail" v-if="property.data.buildingUse.includes('区分')">
                        <dl class="propertyCard__dl" style="width: 100%;">
                            <div>
                                <dt class="propertyCard__dt">住所：</dt>
                                <dd class="propertyCard__dd">{{ property.data.address }}</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">最寄り駅：</dt>
                                <dd class="propertyCard__dd">{{ property.data.station.name }}</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">駅距離：</dt>
                                <dd class="propertyCard__dd">{{ property.data.station.distance }}m（徒歩{{ property.data.station.walk_minutes }}分）</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">専有面積：</dt>
                                <dd class="propertyCard__dd">{{ property.data.occupiedArea }}㎡（{{ property.data.occupiedAreaTsubo }}坪）</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">専有坪単価：</dt>
                                <dd class="propertyCard__dd">{{ changeJpPrice(property.data.occupiedAreaPerUnit) }}円/坪</dd>
                            </div>
                        </dl>
                        <dl class="propertyCard__dl" style="width: 100%;">
                            <div>
                                <dt class="propertyCard__dt">建物構造：</dt>
                                <dd class="propertyCard__dd">{{ property.data.buildingStructure }} {{ property.data.buildingFloors }}</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">築年数：</dt>
                                <dd class="propertyCard__dd">{{ property.data.buildingOld }}年</dd>
                            </div>
                            <div v-if="property.data.remaining_useful_life">
                                <dt class="propertyCard__dt">残存耐用年数：</dt>
                                <dd class="propertyCard__dd">{{ property.remainingUsefulLife() }}</dd>
                            </div>
                            <div v-if="property.rentPrice()">
                                <dt class="propertyCard__dt">月額賃料：</dt>
                                <dd class="propertyCard__dd">{{ changeJpPrice(property.rentPrice()) }}円/坪</dd>
                            </div>
                            <div v-if="property.data.rentMonthlyTsuboPrice">
                                <dt class="propertyCard__dt">月額賃料坪単価：</dt>
                                <dd class="propertyCard__dd">{{ addConma(property.data.rentMonthlyTsuboPrice) }}円</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">取得日時：</dt>
                                <dd class="propertyCard__dd">{{ dateFormat(property.data.acquisitionDate) }}</dd>
                            </div>
                        </dl>
                    </div>
                    <div class="propertyCard__detail" v-else>
                        <dl class="propertyCard__dl" style="width: 100%;">
                            <div>
                                <dt class="propertyCard__dt">住所：</dt>
                                <dd class="propertyCard__dd">{{ property.data.address }}</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">最寄り駅：</dt>
                                <dd class="propertyCard__dd">{{ property.data.station.name }}</dd>
                            </div>
                             <div v-if="property.data.station.distance">
                                <dt class="propertyCard__dt">駅距離：</dt>
                                <dd class="propertyCard__dd">{{ property.data.station.distance }}m（徒歩{{ property.data.station.walk_minutes }}分）</dd>
                            </div>
                            <div v-if="property.data.landArea">
                                <dt class="propertyCard__dt">土地面積：</dt>
                                <dd class="propertyCard__dd">{{ property.data.landArea }}㎡（{{ property.data.landAreaTsubo }}坪）</dd>
                            </div>
                            <div v-if="property.data.landAreaPerUnit">
                                <dt class="propertyCard__dt">土地坪単価：</dt>
                                <dd class="propertyCard__dd">{{ changeJpPrice(property.data.landAreaPerUnit) }}円/坪</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">建物構造：</dt>
                                <dd class="propertyCard__dd">{{ property.data.buildingStructure }} {{ property.data.buildingFloors }}</dd>
                            </div>
                        </dl>
                        <dl class="propertyCard__dl" style="width: 100%;">
                            <div>
                                <dt class="propertyCard__dt">延床面積：</dt>
                                <dd class="propertyCard__dd">{{ property.data.totalFloorArea }}㎡（{{ property.data.totalFloorAreaTsubo }}坪）</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">延床坪単価：</dt>
                                <dd class="propertyCard__dd">{{ changeJpPrice(property.data.totalFloorAreaPerUnit) }}円/坪</dd>
                            </div>
                            <div v-if="property.data.totalUnits && property.data.buildingUse.includes('一棟')">
                                <dt class="propertyCard__dt">総賃貸戸数：</dt>
                                <dd class="propertyCard__dd">{{ property.data.totalUnits }}戸</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">築年数：</dt>
                                <dd class="propertyCard__dd">{{ property.data.buildingOld }}年</dd>
                            </div>
                           <div v-if="property.data.remaining_useful_life != null">
                                <dt class="propertyCard__dt">残存耐用年数：</dt>
                                <dd class="propertyCard__dd">{{ property.remainingUsefulLife() }}</dd>
                            </div>
                            <div v-if="property.rentPrice()">
                                <dt class="propertyCard__dt">月額賃料：</dt>
                                <dd class="propertyCard__dd">{{ changeJpPrice(property.rentPrice()) }}円</dd>
                            </div>
                            <div v-if="property.data.rentMonthlyTsuboPrice">
                                <dt class="propertyCard__dt">月額賃料坪単価：</dt>
                                <dd class="propertyCard__dd">{{ addConma(property.data.rentMonthlyTsuboPrice) }}円</dd>
                            </div>
                            <div>
                                <dt class="propertyCard__dt">取得日時：</dt>
                                <dd class="propertyCard__dd">{{ dateFormat(property.data.acquisitionDate) }}</dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>

        <!-- footer -->
        <div class="propertyCard__footer">
            <div class="portalBtn-group">
                <el-switch
                    v-model="property.data.isPublic"
                    active-text="公開"
                    inactive-text="非公開"
                    @change="actionChange"
                ></el-switch>
            </div>
        </div>

        <a :href="property.data.url" target="_blank" class="propertyCard__link"></a>
    </div>
</template>

<script>
import BaseTag from '@/components/atoms/tags/BaseTag'
import AuthRepository from '@/infrastructure/repositories/AuthRepository'
import { changeJpPrice, addConma } from '@/utils/price'
import { format } from '@/utils/date'

export default {
    name: 'PropertyCard',

    components: {
        BaseTag
    },

    props: {
        property: {
            type: Object,
            required: false
        }
    },

    computed: {
        isLoggedIn() {
            return AuthRepository.isLoggedIn()
        }
    },

    methods: {
        changeJpPrice(price) {
            return changeJpPrice(price)
        },
        addConma(price) {
            return addConma(price)
        },
        dateFormat(date) {
            return format(date)
        },
        actionChange() {
            this.$emit('changePublicStatus', this.property)
        }
    },
}
</script>

<style lang="scss" scoped>
.propertyCard {
    &__footer {
        height: 50px;
        position: relative;
    }
}


// ボタン
.portalBtn-group {
    display: flex;
    justify-content: flex-end;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    height: 100%;
    position: absolute;
    right: 1px;
    z-index: 10;

    @media screen and (max-width: 414px) {
        justify-content: space-around;
        width: 100%;
    }

    & > div {
        margin-right: 20px;

        @media screen and (max-width: 414px) {
           margin: 0 10px;
        }
    }
}
</style>